import { useLocation } from "react-router-dom";
import CustomTitle from "../../../../components/CustomMiscellaneous/CustomTitle";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../../../services/api.service";
import TableView from "../../../Common/TableView";
import { ProjetoConfig } from "./ProjetoConfig";


export default function Projeto() {


    const location = useLocation();
    const currentRoute = location.pathname;
    const obraId = currentRoute.split("/")[2];
    const pecaId = currentRoute.split("/")[4];

    const EXTENSION = `/obras/${obraId}/pecas/${pecaId}/operacoes/Projeto`;

    return(<>{EXTENSION?<div>
        <CustomTitle small text={'Operações de Projeto'}/>
        <TableView 
        title={"Operações de Projeto"}
        postEntity={genericPost(EXTENSION)}
        editEntity={genericUpdate(EXTENSION)}
        deleteEntity={genericDelete(EXTENSION)}
        addButtonText={"Nova Operação"} 
        searchButtonText={"Procurar Operação"}
        tableConfigs={ProjetoConfig}
        dataBuildFunction={generalObjectBuilder(ProjetoConfig)}
        entityName={"Operações Projeto"}
        idProp={"id"}
        configMapKey={`obras/${obraId}/pecas/${pecaId}/operacoes/Projeto`}
        hidePagination
        hideFilters
        reroute={true}
        isSubTable
          />
    </div>:null}</>)

}